<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-data
          titulo="Información del Equipo"
          :datos="computadoraDatos">
        </app-data>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Equipo</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'computadoraDatos/getField',
  mutationType: 'computadoraDatos/updateField',
});

export default {
  name: 'ComputadoraData',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'computadoraDatos',
    ]),
  },  
  created() {
    this.id= this.$route.params.id
    
    this.tableBusy = true;
    this.$store.dispatch('computadoraDatos/getDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'Bienes' }); 
    },
    editar() {
      this.$router.push({ name: 'ComputadoraEdit', 
                          params: { id: this.id }});
    },
  }
}
</script>
